namespace Areas.Dialogs {
    "use strict";

    export class CreateDaUclaDialog extends Areas.BaseDialog {

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void) {
            super("CreateDaUcla", closeHandler);
        }

        protected ok = (e: any) => {
            const form = $("#CreateDaUclaForm").dxForm("instance");
            const result: any = form.validate();
    
            if (result.isValid) {
                const newData: any = form.option("formData");
               
                sendRequest("/Dialog/CreateDaUcla/Post", JSON.stringify(newData), "POST");
            }
        } 
    }    
}